import { Facebook, Linkedin, Mail, Share2 } from "lucide-react";

const XIcon = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M18.244 2H21.5l-7.522 8.59L22.75 22h-6.756l-5.292-6.92L4.7 22H1.44l8.06-9.205L1.5 2h6.91l4.79 6.353L18.244 2z" />
    </svg>
);

export const SocialShare = ({ url, title = "Sign the petition for JC Law. Every second matters.", testidPrefix = "share" }) => {
    const enc = encodeURIComponent;
    const safeUrl = url || (typeof window !== "undefined" ? window.location.href : "https://jclawsc.org");
    const links = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(safeUrl)}`,
        twitter: `https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(safeUrl)}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(safeUrl)}`,
        email: `mailto:?subject=${enc(title)}&body=${enc(title + " " + safeUrl)}`,
    };

    const handleNative = async () => {
        if (navigator.share) {
            try {
                await navigator.share({ title, url: safeUrl, text: title });
            } catch (_) {
                /* user cancelled */
            }
        } else {
            navigator.clipboard?.writeText(safeUrl);
        }
    };

    return (
        <div className="flex items-center gap-2 flex-wrap" data-testid={`${testidPrefix}-bar`}>
            <span className="text-xs uppercase tracking-[0.22em] text-navy-700/60 mr-1">Share</span>
            <a href={links.facebook} target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook" data-testid={`${testidPrefix}-facebook`} className="w-9 h-9 border border-navy-900/15 hover:bg-navy-900 hover:text-editorial hover:border-navy-900 transition-colors flex items-center justify-center">
                <Facebook size={16} />
            </a>
            <a href={links.twitter} target="_blank" rel="noopener noreferrer" aria-label="Share on X/Twitter" data-testid={`${testidPrefix}-twitter`} className="w-9 h-9 border border-navy-900/15 hover:bg-navy-900 hover:text-editorial hover:border-navy-900 transition-colors flex items-center justify-center">
                <XIcon />
            </a>
            <a href={links.linkedin} target="_blank" rel="noopener noreferrer" aria-label="Share on LinkedIn" data-testid={`${testidPrefix}-linkedin`} className="w-9 h-9 border border-navy-900/15 hover:bg-navy-900 hover:text-editorial hover:border-navy-900 transition-colors flex items-center justify-center">
                <Linkedin size={16} />
            </a>
            <a href={links.email} aria-label="Share via Email" data-testid={`${testidPrefix}-email`} className="w-9 h-9 border border-navy-900/15 hover:bg-navy-900 hover:text-editorial hover:border-navy-900 transition-colors flex items-center justify-center">
                <Mail size={16} />
            </a>
            <button type="button" onClick={handleNative} aria-label="Native share" data-testid={`${testidPrefix}-native`} className="w-9 h-9 border border-navy-900/15 hover:bg-navy-900 hover:text-editorial hover:border-navy-900 transition-colors flex items-center justify-center">
                <Share2 size={16} />
            </button>
        </div>
    );
};

export default SocialShare;
